/*
 * @Author: LiuMeiYu
 * @Date: 2023-03-02 10:31:31
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-12-19 14:15:32
 * @FilePath: \ValueSwap_web\src\router\index.ts
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
/*
 * @Author: LiuMeiYu
 * @Date: 2022-10-24 11:57:27
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-02 10:30:22
 * @FilePath: \cardtey\src\router\index.ts
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "contact",
  },
  {
    path: "/contact",
    name: "ContactUs",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/ContactUsView.vue"),
    meta: {
      title: "ValueSwap",
      requireAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
